import script from "./XSlider.vue?vue&type=script&lang=ts&setup=true"
export * from "./XSlider.vue?vue&type=script&lang=ts&setup=true"

import "./XSlider.vue?vue&type=style&index=0&id=6cf5863f&lang=scss"

const __exports__ = script;

export default __exports__